export const environment = {
    production: false,
    host: 'https://dev.payme-9kp.pages.dev',
    port:'4200',
    brandName : 'PayMe-dev',
    apiBaseUrl: 'https://dev.payme-9kp.pages.dev/api',
    accountId : '3NzMTmQYHlQ-PMBgteRWVw',
    paypalBaseUrl: 'https://api-m.sandbox.paypal.com',
    firebaseConfig: {
        apiKey: "AIzaSyCjv3ujxdF38vu768k-uMeBhOmGbnS3KSc",
        authDomain: "publichomepage-5e16d.firebaseapp.com",
        projectId: "publichomepage-5e16d",
        storageBucket: "publichomepage-5e16d.firebasestorage.app",
        messagingSenderId: "456000203028",
        appId: "1:456000203028:web:b4c7ce1f0a92293015fa01",
        measurementId: "G-VW0QTXYY89"
    }
};
